import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { environment } from '@environments';
import { AnalyticsService } from '@serasa/shared/services/analytics.service';
import { MinitokenService } from '@serasa/shared/services/minitoken.service';
import { SharedModule } from '@serasa/shared/shared.module';

@Component({
    selector: 'pl-sub-menu',
    templateUrl: './sub-menu.component.html',
    styleUrls: ['./sub-menu.component.scss'],
    imports: [CommonModule, RouterLink, RouterLinkActive, RouterModule, SharedModule]
})
export class SubMenuComponent implements OnInit {
  constructor(
    private readonly _minitokenService: MinitokenService,
    private readonly _analyticsService: AnalyticsService
  ) {}

  public environment = environment;
  public hideButtons = false;

  private _blackList = ['privacy-terms', 'recertification'];

  ngOnInit() {
    const pathName = location.pathname.split('/').reverse()[0];
    this.hideButtons = this._blackList.includes(pathName);
  }

  public redirect(item: { url: string, targetClientId: string }): void {
    const { targetClientId, url } = item;

    if (targetClientId) {
      this._minitokenService.generateMinitokenAndRedirect(url, targetClientId);
    } else {
      window.open(url, '_blank');
    }
  }

  public actionAnalytic(dataTestId: string): void {
    if (dataTestId === 'auto-atendimento') {
      this._analyticsService.doCustomEvent(
        {
          events: ['portalLogons_AutoAtendimento'],
          flowName: 'MP:LG:IN:PortalDeLogons:AutoAtendimento',
        },
        'PortalDeLogonsAutoAtendimento'
      );
    } else if (dataTestId === 'central-de-ajuda') {
      this._analyticsService.doCustomEvent(
        {
          events: ['portalLogons_CentralDeAjuda'],
          flowName: 'MP:LG:IN:PortalDeLogons:CentralDeAjuda',
        },
        'PortalDeLogonsCentralDeAjuda'
      );
    }
  }
}
